"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceEnum = exports.CountryEnum = exports.CountyEnum = exports.CityEnum = exports.VillageEnum = exports.RoadEnum = exports.HouseNumberEnum = void 0;
var HouseNumberEnum;
(function (HouseNumberEnum) {
    HouseNumberEnum["house_number"] = "house_number";
})(HouseNumberEnum || (exports.HouseNumberEnum = HouseNumberEnum = {}));
var RoadEnum;
(function (RoadEnum) {
    RoadEnum["road"] = "road";
})(RoadEnum || (exports.RoadEnum = RoadEnum = {}));
var VillageEnum;
(function (VillageEnum) {
    VillageEnum["village"] = "village";
})(VillageEnum || (exports.VillageEnum = VillageEnum = {}));
var CityEnum;
(function (CityEnum) {
    CityEnum["city"] = "city";
    CityEnum["town"] = "town";
})(CityEnum || (exports.CityEnum = CityEnum = {}));
var CountyEnum;
(function (CountyEnum) {
    CountyEnum["county"] = "county";
})(CountyEnum || (exports.CountyEnum = CountyEnum = {}));
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["country"] = "country";
})(CountryEnum || (exports.CountryEnum = CountryEnum = {}));
var PlaceEnum;
(function (PlaceEnum) {
    PlaceEnum["restaurant"] = "restaurant";
    PlaceEnum["pub"] = "pub";
    PlaceEnum["bar"] = "bar";
    PlaceEnum["arts_centre"] = "arts_centre";
    PlaceEnum["castle"] = "castle";
    PlaceEnum["hotel"] = "hotel";
    PlaceEnum["motel"] = "motel";
    PlaceEnum["cinema"] = "cinema";
    PlaceEnum["fast_food"] = "fast_food";
    PlaceEnum["cafe"] = "cafe";
    PlaceEnum["guest_house"] = "guest_house";
    PlaceEnum["fuel"] = "fuel";
    PlaceEnum["bakery"] = "bakery";
    PlaceEnum["shop"] = "shop";
})(PlaceEnum || (exports.PlaceEnum = PlaceEnum = {}));
//# sourceMappingURL=GeocoderResultDto.js.map